import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';



export default function Label({ style, children, onClick, type }) {
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <span
      style={style}
      onClick={onClick}
      className={`label ${type}`}
    >
      {children}
    </span>
  );
}

Label.propTypes = {
  style: PropTypes.shape(),
  children: PropTypes.node,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['title', 'form', 'error']).isRequired,
};

Label.defaultProps = {
  style: {},
  children: '',
  onClick: () => {},
};

